module.exports = __webpack_public_path__ + "static/pomcl-102-rr-8c962a02cce8e9f6c29f067fa78ad64e.webp";